import { makeStyles } from '@material-ui/core'

export const useStyles = makeStyles(theme => ({
  tabContainer: {
    padding: theme.spacing(2)
  },
  popoverPaper: {
    width: '50%',
    // marginLeft: theme.spacing(2),
    // marginRight: theme.spacing(1),
    padding: theme.spacing(2),
    [theme.breakpoints.down('sm')]: {
      maxWidth: '100%'
    }
  },
  switch: {
    marginRight: '10px !important'
  },
  gridItem: {
    display: 'flex',
    alignItems: 'center',
    marginTop: '22px'
  },
  gridItemFlex: {
    display: 'flex',
    alignItems: 'center',
    gap: '8px'
  },
  iconButtonAction: {
    padding: '0px !important',
    color:
      theme.palette.type === 'dark'
        ? theme.palette.dark_50.main
        : theme.palette.gray_300.main,
    transition: 'all 0.2s ease-in-out',
    '&:hover': {
      backgroundColor: 'transparent',
      color: theme.palette.blue_300.main
    }
  },
  icons: {
    '&:hover': {
      backgroundColor: 'transparent'
    },
    color:
      theme.palette.type === 'dark'
        ? theme.palette.dark_50.main
        : theme.palette.white_100.main
  },
  customBadge: {
    backgroundColor: '#f44336',
    color: '#fff'
  },
  console: {
    height: '400px',
    width: '100%',
    backgroundColor:
      theme.palette.type === 'dark'
        ? theme.palette.dark_700.main
        : theme.palette.gray_100.main,
    color:
      theme.palette.type === 'dark'
        ? theme.palette.dark_50.main
        : theme.palette.gray_400.main,
    padding: theme.spacing(2),
    overflowY: 'auto',
    overflowX: 'auto',
    fontFamily: 'monospace',
    ...theme.scrollbarStylesSoft
  },
  logline: {
    display: 'flex',
    alignItems: 'flex-start',
    cursor: 'text',
    '&:hover': {
      cursor: 'pointer',
      backgroundColor:
        theme.palette.type === 'dark'
          ? theme.palette.dark_400.main
          : theme.palette.gray_100.main
    }
  },
  logMetadata: {
    flexShrink: 0,
    margin: 0
  },
  logExpand: {
    flexShrink: 0,
    marginLeft: 8,
    cursor: 'pointer',
    '& svg': {
      color: theme.palette.type === 'dark' ? theme.palette.dark_50.main : theme.palette.gray_300.main
    }
  },
  logMessage: {
    flexGrow: 1,
    overflow: 'hidden',
    textOverflow: 'ellipsis',
    whiteSpace: 'nowrap',
    margin: 0,
    marginLeft: 8
  },
  logDetails: {
    flexGrow: 1,
    overflow: 'auto',
    margin: 0,
    marginLeft: 8,
    maxHeight: 200,
    ...theme.scrollbarStylesSoft
  },
  grid: {
    padding: theme.spacing(2)
  },
  error: {
    fontWeight: 'bold',
    color: theme.palette.red_100.main
  },
  warn: {
    fontWeight: 'bold',
    color: theme.palette.yellow_400.main
  },
  info: {
    fontWeight: 'bold',
    color: theme.palette.green_200.main
  },
  debug: {
    fontWeight: 'bold',
    color: theme.palette.blue_300.main
  },
  trace: {
    fontWeight: 'bold',
    color: theme.palette.orange_400.main
  }
}))
